<template>
  <div class="health-and-wellness" v-if="$root.dataReady">
    <div class="hero">
      <div class="header">
        <img
          class="logo"
          height="76"
          src="https://webershandwick.co.uk/wp-content/uploads/2023/03/weber_w_logotype_rgb_white.png"
          width="76"
        />
        <a class="button" href="#mc_embed_shell">Get in touch</a>
      </div>
      <div class="container">
        <div class="text">
          <h1
            class="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            A renewed focus on Health & Wellness
          </h1>
        </div>
      </div>
      <div
        class="bg"
        :style="{
          'background-image':
            'url(https://webershandwick.co.uk/wp-content/uploads/2023/07/hero-health-scaled-1.jpeg)',
        }"
      ></div>
    </div>
    <div class="hero-info">
      <h1
        class="aos-init aos-animate"
        data-aos="fade-up"
        data-aos-delay="500"
      ></h1>
      <p class="black-text">
        "We decode today’s health and wellbeing information overload, helping
        brands rise above the noise and putting people in control of their
        health journey."
      </p>
      <p class="signature-text">
        Anna Gallais, Managing Director, Consumer Health & Wellness, EMEA
      </p>
    </div>

    <div class="video-wrapper">
      <iframe
        src="https://www.youtube.com/embed/s0WjUdGQfm8?rel=0"
        width="100%"
        height="100%"
        frameborder="0"
      ></iframe>
    </div>

    <div class="video-description">
      <h2>MEET THE TEAM</h2>
      <p class="video-description--text">
        Our Consumer Health & Wellness team, comprising specialists across the
        EMEA region, works with brands offering a diverse range of products and
        services: from over the counter medication and FMCG, to delivering
        health benefits and wellbeing apps. Creativity is what drives us and,
        importantly, it’s what moves people too – explore our work below.
        <br />
        <br />
        For unique Consumer Health and Wellness insights, view our latest trends
        report
        <a
          href="https://webershandwick.co.uk/wp-content/uploads/2023/07/Consumer-Healthcare_Forecast-24-July-2023.pdf"
          target="_blank"
          >here</a
        >.
        <br />
        <br />
      </p>
      <p class="video-description--text-bold">
        To learn more, please <a href="#mc_embed_shell">get in touch</a> – we
        would love to hear from you.
      </p>
    </div>

    <div class="persons">
      <h2>KEY WORK</h2>
      <div class="persons-interviews">
        <div class="person-interview">
          <iframe
            src="https://player.vimeo.com/video/840080797?h=e4430a6b6f"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
          <p class="person-title">The Uncover for Frida</p>
          <p class="person-description">
            In France, breastfeeding in public remains controversial. Mothers
            face harassment every day. Maternity-wear brand, Frida, wanted to
            normalise and destigmatise breastfeeding. We designed a cover that
            made breastfeeding as normal as reading a magazine.
          </p>
        </div>
        <div class="person-interview">
          <iframe
            src="https://player.vimeo.com/video/822950191?h=9de1e89d0b"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
          <p class="person-title">Field 100 for Dr. Schär</p>
          <p class="person-description">
            With 66% of crops coming from just nine species, global food
            security at risk. We helped Dr Schär cultivate the world’s most
            biodiverse field as a platform for major research and natural event
            space for next level field trips.
          </p>
        </div>
        <div class="person-interview">
          <iframe
            src="https://player.vimeo.com/video/670717613?h=225ea7586d"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
          <p class="person-title">Coldish for Sensodyne</p>
          <p class="person-description">
            Ice-cream is one of the joys of summer but two in five people have
            sensitive teeth so can’t enjoy it. Sensodyne wanted to start a
            conversation about summertime oral-sensitivity so we invented
            Coldish, the world’s first lukewarm ice-cream…
          </p>
        </div>
      </div>
    </div>

    <div id="mc_embed_shell">
      <link
        href="//cdn-images.mailchimp.com/embedcode/classic-061523.css"
        rel="stylesheet"
        type="text/css"
      />

      <div id="mc_embed_signup">
        <form
          action="https://webershandwick.us21.list-manage.com/subscribe/post?u=cbecd27708abff5429c48ef87&amp;id=8be544c9f2&amp;v_id=152&amp;f_id=00e55fe1f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          class="validate"
          target="_blank"
        >
          <div id="mc_embed_signup_scroll">
            <h2>GET IN TOUCH</h2>
            <div class="mc-field-group">
                <p><strong>If you would like to connect with a member of our team and tap into further consumer health & wellness trends and insights, please provide your details below.</strong></p>
            </div>
            <div class="indicates-required">
              <span class="asterisk">*</span> indicates required
            </div>
            <div class="mc-field-group">
              <label for="mce-EMAIL"
                >Email Address <span class="asterisk">*</span></label
              ><input
                type="email"
                name="EMAIL"
                class="required email"
                id="mce-EMAIL"
                required=""
                value=""
              />
            </div>
            <div class="mc-field-group">
              <label for="mce-FNAME"
                >First Name <span class="asterisk">*</span></label
              ><input
                type="text"
                name="FNAME"
                class="required text"
                id="mce-FNAME"
                required=""
                value=""
              />
            </div>
            <div class="mc-field-group">
              <label for="mce-LNAME"
                >Last Name <span class="asterisk">*</span></label
              ><input
                type="text"
                name="LNAME"
                class="required text"
                id="mce-LNAME"
                required=""
                value=""
              />
            </div>
            <div class="mc-field-group">
              <label for="mce-MMERGE5">Job title (incl. organisation) </label
              ><input
                type="text"
                name="MMERGE5"
                class="text"
                id="mce-MMERGE5"
                value=""
              />
            </div>
            <div
              id="mergeRow-gdpr"
              class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group"
            >
              <div class="content__gdpr">
                <label>Marketing Permissions</label>
                <p>Please select all the ways you would like to hear from :</p>
                <fieldset
                  class="mc_fieldset gdprRequired mc-field-group"
                  name="interestgroup_field"
                >
                  <label class="checkbox subfield" for="gdpr1320"
                    ><input
                      type="checkbox"
                      id="gdpr_1320"
                      name="gdpr[1320]"
                      class="gdpr"
                      value="Y"
                    /><span>Email</span></label
                  >
                </fieldset>
                <p>
                  You can unsubscribe at any time by clicking the link in the
                  footer of our emails. For information about our privacy
                  practices, please visit our website.
                </p>
              </div>
              <div class="content__gdprLegal">
                <p>
                  We use Mailchimp as our marketing platform. By clicking below
                  to subscribe, you acknowledge that your information will be
                  transferred to Mailchimp for processing.
                  <a href="https://mailchimp.com/legal/terms">Learn more</a>
                  about Mailchimp's privacy practices.
                </p>
              </div>
            </div>
            <div id="mce-responses" class="clearfalse">
              <div
                class="response"
                id="mce-error-response"
                style="display: none"
              ></div>
              <div
                class="response"
                id="mce-success-response"
                style="display: none"
              ></div>
            </div>
            <div aria-hidden="true" style="position: absolute; left: -5000px">
              <input
                type="text"
                name="b_cbecd27708abff5429c48ef87_8be544c9f2"
                tabindex="-1"
                value=""
              />
            </div>
            <div class="clear">
              <input
                type="submit"
                name="subscribe"
                id="mc-embedded-subscribe"
                class="button"
                value="SUBMIT"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script
  type="text/javascript"
  src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
></script>
<script type="text/javascript">
(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]=EMAIL;ftypes[0]=merge;,fnames[1]=FNAME;ftypes[1]=merge;,fnames[2]=LNAME;ftypes[2]=merge;,fnames[5]=MMERGE5;ftypes[5]=merge;,fnames[3]=ADDRESS;ftypes[3]=merge;,fnames[4]=PHONE;ftypes[4]=merge;false}(jQuery));var $mcj = jQuery.noConflict(true);
</script>

<script>
import VideoWrapper from "../components/VideoWrapper.vue";
import Block from "../components/Block.vue";

export default {
  name: "health-and-wellness",
  data() {
    return {
      blocks: null,
      page: null,
    };
  },
  components: {
    Block,
    VideoWrapper,
  },
  created: function () {
    this.$root.dataReady = false;
    this.$root.headeriswhite = false;
    this.$root.headerIsVisible = false;
    this.$root.smallFooter = true;
  },
  mounted: function () {
    this.fetchData();
  },
  updated: function () {
    if (this.$root.dataReady) {
      $("div.wpcf7 > form").each(function () {
        var $form = $(this);
        wpcf7.init($form[0]);
        if (wpcf7.cached) {
          wpcf7.refill($form);
        }
      });
    }
  },
  props: ["slug"],
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/pages?slug=" + self.slug,
        function (response) {
          self.blocks = response[0].acf.block_grid;
          self.page = response[0];
          self.setTitle(response[0].title.rendered);
          self.$root.dataReady = true;
        }
      )
        .done(function () {})
        .fail(function () {});
    },
    setTitle: function (title) {
      title = title.normalize("NFD").replace("&#038;", "&");
      document.title = title + " - Weber Shandwick";
    },
  },
};
</script>



// WEBPACK FOOTER //
// HealthAndWellness.vue?1cf5ded6